import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    isLoading: false,
};
// TODO: (A.H.) - need separeted functions for state changes.
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.request, (state) => ({
        ...state,
        isLoading: true,
    }))
        .addCase(actions.success, (state, action) => ({
        ...state,
        ...action.payload,
        isLoading: false,
    }))
        .addCase(actions.failure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    }));
});
